var _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgCloud3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 722,
    height: 493,
    viewBox: "0 0 722 493",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65,
    filter: "url(#filter0_f_2701_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1174.42 597.73C1107.02 620.776 1027.81 580.445 976.635 504.271C959.621 554.704 926.555 593.203 880.499 608.954C816.51 630.803 743.336 603.304 686.477 543.967C672.087 599.825 641.907 640.942 597.951 655.945C519.31 682.807 420.636 618.12 353.236 504.982C338.19 524.287 318.901 538.804 295.808 546.698C210.912 575.693 107.384 504.346 64.5203 387.355C21.6569 270.364 55.729 151.988 140.581 122.956C188.912 106.456 243.278 122.469 289.028 160.93C303.724 106.681 333.597 66.8358 376.723 52.0576C453.702 25.7561 549.882 87.1886 617.108 195.874C635.74 159.583 664.345 132.309 701.26 119.663C784.931 91.0796 884.348 146.975 942.432 248.028C958.353 212.56 984.552 185.81 1019.19 173.95C1104.09 144.955 1207.62 216.302 1250.48 333.293C1293.34 450.284 1259.27 568.66 1174.42 597.692V597.73Z",
    fill: "url(#paint0_linear_2701_1008)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2701_1008",
    x: 0,
    y: 0,
    width: 1315,
    height: 708,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23,
    result: "effect1_foregroundBlur_2701_1008"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2701_1008",
    x1: 863.047,
    y1: -91.0107,
    x2: 398.342,
    y2: 1118.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182692,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389423,
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567308,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud3);
export default __webpack_public_path__ + "static/media/cloud_3.6ee119935d2e460492922fafd0ea9cf4.svg";
export { ForwardRef as ReactComponent };